import { render, staticRenderFns } from "./TutorialArrow.vue?vue&type=template&id=328b3fcb&lang=pug"
import script from "./TutorialArrow.vue?vue&type=script&lang=js"
export * from "./TutorialArrow.vue?vue&type=script&lang=js"
import style0 from "./TutorialArrow.vue?vue&type=style&index=0&id=328b3fcb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports